import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Signin from '../components/Signin';
import PropTypes from 'prop-types';

const withAuthorization = Component => {
  class WithAuthorization extends React.Component {
    constructor(props) {
      super(props);
      const { user } = this.props;
      this.state = {
        user,
      };
    }

    componentWillReceiveProps(nextProps) {
      const { user } = nextProps;
      this.setState(user);
      console.log('state');
      console.log(this.state);
    }
    render() {
      const { user } = this.state;
      console.log(user);
      return user ? <Component {...this.props} /> : <Signin />;
    }
  }

  function mapStateToProps(state) {
    const { authentication } = state;
    const { user } = authentication;
    return {
      user,
    };
  }

  WithAuthorization.propTypes = {
    history: PropTypes.object,
    user: PropTypes.object,
  };

  return connect(mapStateToProps)(withRouter(WithAuthorization));
};

export default withAuthorization;



// WEBPACK FOOTER //
// ./src/utils/withAuthorization.js